<script>
import {slugify} from '@/helpers/strings';
import {useConfig} from '@/helpers/config-effect';

export default {
  name: 'ActionSettings',
  template: '#action-settings-template',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const config = useConfig();

    const actions = config.actions;
    const actionsGroups = {};

    Object.values(actions).forEach(action => {
      if (!actionsGroups.hasOwnProperty(action.group)) {
        actionsGroups[action.group] = {
          name: action.group,
          actions: [],
        };
      }

      actionsGroups[action.group].actions.push(action);
    });

    return {
      actionsGroups: Object.values(actionsGroups),
      actions,
      set actionName(value) {
        props.node.properties.name = slugify(value, '-') || '';
      },
      get actionName() {
        return props.node.properties.name;
      },
    };
  },
};
</script>
